import { Wrapper } from '@american-autonomy/ag-ui';

import SingleSelectPanel from 'components/SingleSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { ENTITY_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

const ClientSelectPanelField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    onClose,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { clientItems, handleAsyncFilter, hasNextPage, isLoading, noItemsText, onNextPage } =
        useData();

    const handleClick = (client: Item) => {
        onChange(client);
        onClose?.(client);
    };

    return (
        <Wrapper className={className} testId={testId}>
            <SingleSelectPanel
                entityType={ENTITY_TYPE}
                hasNextPage={hasNextPage}
                isLoading={isLoading}
                itemSelected={value}
                items={clientItems}
                label={SEARCH}
                noItemsFoundText={noItemsText}
                onFilter={handleAsyncFilter}
                onNextPage={onNextPage}
                onSelected={handleClick}
            />
        </Wrapper>
    );
};

export default ClientSelectPanelField;
